export default {
  nome: {
    value: '',
    required: true,
    state: null
  },
  // url: {
  //   value: '',
  //   required: false,
  //   state: null
  // },
  usuario: {
    value: '',
    required: true,
    state: null
  },
  senha: {
    value: '',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/campaign/whatsapp/components/add/campanhawhatsappadd-form.js